<div class="deposit">
  <div class="deposit-amount">
    <p class="label">Debes depositar</p>
    <p class="amount">
      @if(dataDeposit.side === 'BUY') {
      {{ dataDeposit.depositAmount | formatCoinAmount : 'ARS' }}
      <span>{{ dataDeposit.against === 'ARS' ? 'AR$' : dataDeposit.against }}</span>
      <button mat-icon-button>
        <mat-icon>
          <img
            class="copy"
            [src]="
              isCopiedAmount
                ? 'assets/icons/circular-tick.svg'
                : 'assets/icons/news/copy_violet.svg'
            "
            alt="copy"
            (click)="
              !isCopiedAmount &&
                copyToClipboard(dataDeposit.depositAmount.toString(), false, false, true)
            "
            [class.fade]="isCopiedAmount"
          />
        </mat-icon>
      </button>
      } @else {
      {{ dataDeposit.depositAmount | formatCoinAmount : 'STABLES' }}
      <span class="asset">{{ dataDeposit.asset }}</span>
      <img
        [src]="
          'assets/icons/crypto/' +
          (dataDeposit.asset === 'USDCB' ? 'usdc' : dataDeposit.asset.toLowerCase()) +
          '.svg'
        "
        alt="coin"
      />
      }
    </p>
    <div class="wld-amount">
      <ng-container *ngIf="dataDeposit.withdrawAmount">
        <p>
          Obtenés:
          <span>
            {{ dataDeposit.withdrawAmount | formatCoinAmount : 'ARS' }}
            {{
              dataDeposit.side === 'BUY'
                ? dataDeposit.asset === 'USDCB'
                  ? 'USDC'
                  : dataDeposit.asset
                : dataDeposit.against
            }}</span
          >
        </p>
        <img
          [src]="
            dataDeposit.side === 'BUY'
              ? 'assets/icons/crypto/' +
                (dataDeposit.asset === 'USDCB' ? 'usdc' : dataDeposit.asset.toLowerCase()) +
                '.svg'
              : 'assets/icons/flags/' + dataDeposit.against + '.svg'
          "
          alt="coin"
        />
      </ng-container>
      <ng-container *ngIf="!dataDeposit.withdrawAmount">
        <mat-spinner [diameter]="16"></mat-spinner>
      </ng-container>
    </div>
    <p class="fee" *ngIf="dataDeposit.withdrawCost">
      Costo estimado de la red: {{ dataDeposit.withdrawCost ?? 0 | formatCoinAmount : 'USD' }}
      {{ dataDeposit.asset === 'USDCB' ? 'USDC' : dataDeposit.asset }}
    </p>
  </div>

  <div class="allow-networks" *ngIf="dataDeposit?.availableDepositNetworks">
    <p>Redes permitidas</p>
    <div class="networks">
      @for (network of dataDeposit?.availableDepositNetworks; track $index){
      <p>
        <img [src]="'assets/icons/news/' + network.toLowerCase() + '-network.svg'" alt="" />
        {{ network }}
      </p>
      }
    </div>
  </div>

  <div class="deposit-account">
    <div class="account-holder" *ngIf="isSixalime">
      <p class="title">Titular de la cuenta</p>
      <p class="name">Sixalime S.A.S</p>
    </div>
    <div class="divider" *ngIf="isSixalime"></div>

    <div class="deposit-info">
      @if(dataDeposit.side === 'BUY'){
      <div class="option">
        @if(depositAddresses[0]?.address === 'dynamic'){
        <div class="qrcode">
          <qrcode
            [qrdata]="depositAddresses[0]?.code"
            [width]="300"
            [elementType]="'svg'"
            [margin]="4"
            [colorDark]="'#000000'"
            [colorLight]="'#ffffff'"
            [allowEmptyString]="true"
            [errorCorrectionLevel]="'H'"
          >
          </qrcode>
          <p>Escanea el código QR</p>
        </div>
        } @else {
        <div class="address">
          <p class="type">Cuenta a depositar</p>
          <p>
            {{ depositAddresses[0]?.address || 'No hay una cuenta de depósito designada' }}
          </p>
        </div>
        <button mat-icon-button *ngIf="depositAddresses[0]?.address">
          <mat-icon>
            <img
              class="copy"
              [src]="
                isCopiedCbu ? 'assets/icons/circular-tick.svg' : 'assets/icons/news/copy_violet.svg'
              "
              alt="copy"
              (click)="!isCopiedCbu && copyToClipboard(depositAddresses[0].address, true)"
              [class.fade]="isCopiedCbu"
            />
          </mat-icon>
        </button>
        }
      </div>
      } @else {
      <div class="option">
        <div class="address">
          <p class="type">Direcciones de depósito</p>
          @for (address of depositAddresses; let i = $index; track i){
          <p class="addresses">
            <span>
              <b> {{ address.network }} </b> <br />
              {{ address.address }}
            </span>
            <button mat-icon-button>
              <mat-icon>
                <img
                  class="copy"
                  [src]="
                    isCopied[i]
                      ? 'assets/icons/circular-tick.svg'
                      : 'assets/icons/news/copy_violet.svg'
                  "
                  alt="copy"
                  (click)="!isCopied[i] && copyToClipboard(address.address, false, false, false, i)"
                  [class.fade]="isCopied[i]"
                />
              </mat-icon>
            </button>
          </p>
          }
        </div>
      </div>
      }
      <div class="option" *ngIf="isSixalime || dataDeposit?.depositAlias">
        <div class="address">
          <p class="type">ALIAS</p>
          <p>{{ dataDeposit?.depositAlias ? dataDeposit?.depositAlias : 'CRYPTO.ARS' }}</p>
        </div>
        <button mat-icon-button>
          <mat-icon>
            <img
              class="copy"
              [src]="
                isCopiedAlias
                  ? 'assets/icons/circular-tick.svg'
                  : 'assets/icons/news/copy_violet.svg'
              "
              alt="copy"
              (click)="
                !isCopiedAlias &&
                  copyToClipboard(
                    dataDeposit?.depositAlias ? dataDeposit?.depositAlias : 'CRYPTO.ARS',
                    false,
                    true
                  )
              "
              [class.fade]="isCopiedAlias"
            />
          </mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div class="select-bank" *ngIf="false">
    <mat-form-field appFormField appearance="outline">
      <mat-label>Seleccionar banco</mat-label>
      <mat-select [formControl]="bankControl">
        <mat-option *ngFor="let bank of banks" [value]="bank.value">
          {{ bank.name }}
        </mat-option>
      </mat-select>
      <mat-error>
        <app-input-hint
          type="error"
          [message]="errorHelper.getErrorMessage(bankControl)"
        ></app-input-hint>
      </mat-error>
    </mat-form-field>
    <button
      (click)="openBankApp()"
      appButton="primary"
      class="max-width"
      [disabled]="!bankControl.value"
      *ngIf="bankControl.value !== 'OTHER_BANK'"
    >
      Abrir app
    </button>
    <p>
      {{
        bankControl.value === 'OTHER_BANK'
          ? 'Ingresa a la app de tu banco y envia los fondos desde tu home banking.'
          : 'Si tu banco no aparece, ingresa y envia los fondos directo desde tu home banking.'
      }}
    </p>
  </div>

  <div class="alerts">
    <app-reminder-message
      class="alert"
      message="Recordá transferir desde una cuenta a tu nombre y no desde cuentas de terceros."
      type="warning"
      *ngIf="dataDeposit.side === 'BUY'"
    ></app-reminder-message>

    <app-reminder-message
      class="alert"
      [message]="
        'La transacción puede demorar hasta ' +
        (dataDeposit.side === 'BUY' ? '15' : '5') +
        ' minutos. En caso de que haya más demora, comunicate con soporte.'
      "
      type="warning"
    ></app-reminder-message>
  </div>
</div>
